module.exports = __webpack_public_path__ + "app/bento-components/blog-river/media/mail.svg?6ed78b2c271bc02e7e7145fdf02f5fb6";